import { ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE } from '@/common/enum/reverse/device'
import { getNumber, toHump, toLine } from '@/utils/common'

/**
 * 提供appConfig 会将其采集间隔抽取出来
 * @param appConfig
 * @returns {{}}
 */
export const transformCollectInterval = (appConfig = {}) => {
  // 用于前端界面展示
  const result = {}
  if (appConfig.collectInterval) {
    result[$t('integration.acquisition_interval')] =
      appConfig.collectInterval
  }
  if (appConfig.exCollectInterval) {
    result[$t('integration.abnormal_collection_interval')] =
      appConfig.exCollectInterval
  }
  if (appConfig.humCollectInterval) {
    result[$t('integration.humidity_collection_interval')] =
      appConfig.humCollectInterval
  }
  if (appConfig.sampleMode) {
    result[$t('device.sample_mode')] = (
      ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE[appConfig.sampleMode] ||
      appConfig.sampleMode
    ).title
  }
  if (appConfig.normalReportInterval) {
    result[$t('device.normal_reporting_interval')] =
      appConfig.normalReportInterval
  }
  if (appConfig.abnormalReportInterval) {
    result[$t('device.abnormal_reporting_interval')] =
      appConfig.abnormalReportInterval
  }
  if (appConfig.sampleInterval) {
    result[$t('device.sample_interval')] = appConfig.sampleInterval
  }

  return result
}

/**
 * 作用：sensor当前配置(服务器返回的数据)格式化
 * 1.将key转换为驼峰式命名
 * 2.提取内部modify的值 写入result
 */
export const transformEditSensorConfig = item => {
  const result = {}

  Object.keys(item).forEach(key => {
    // key转驼峰 将值写入
    result[toHump(key)] = getNumber(item[key].modify)
  })

  return result
}

/**
 * sensorEdit配置转换为view配置(用于渲染界面，带有modify，current，change字段的json结构体)
 * @param data
 */
export const transformViewSensorConfig = data => {
  const result = {}
  result.cmd = ''
  result.base64 = ''
  result.item = {}

  Object.keys(data).forEach(key => {
    result.item[toLine(key)] = {
      current: data[key],
      change: false
    }
  })
  return result
}
